import { Fragment, useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import { addToCart } from "../../store/actions/action";
import Product from "./product";
import api from "../../api";
import ProductTabs from "./alltab";

const ProductSinglePage = ({ addToCart }: { addToCart: Function }) => {
  const { slug } = useParams<{ slug: string }>();

  // ✅ Memoize products so it won’t recreate every render
  const productsArray = useMemo(() => api(), []);
  const [product, setProduct] = useState<any>(null);

  useEffect(() => {
    const found = productsArray.find((item) => item.slug === slug);
    setProduct(found || null);
  }, [slug, productsArray]);

  const addToCartProduct = (product: any, qty = 1) => {
    addToCart(product, qty);
  };

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-1"} />
      <PageTitle pageTitle={"Product Single"} pagesub={"Product Single"} />

      <section className="wpo-shop-single-section section-padding">
        <div className="container">
          {product && <Product item={product} addToCart={addToCartProduct} />}
          <ProductTabs />
        </div>
      </section>

      <Footer footerClass={"wpo-site-footer-s1"} />
      <Scrollbar />
    </Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.data.products,
});

export default connect(mapStateToProps, { addToCart })(ProductSinglePage);
